<template>
  <bet-list
    :loading="loading"
    :list="ticketState?.fullTicketList"
    :summary="ticketState.fullTicketSummary"
    :pagination="ticketState.fullTicketPagination"
    @load-more="onChangePage"
  />
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import BetList from '@/components/Ticket/BetList.vue';
import { useTicketStore } from '../../store/ticket';

export default defineComponent({
  name: 'ContainerBetTable',
  components: {
    BetList,
  },
  setup() {
    const ticketStore = useTicketStore();
    const loading = ref(false);

    const onFetchTicketList = async (page: number) => {
      loading.value = true;
      await ticketStore.getFullTicketList(page);
      loading.value = false;
    };

    const ticketState = computed(() => ticketStore.$state);

    const onChangePage = () => {
      if (!ticketState.value?.fullTicketPagination?.nextPage) return;
      onFetchTicketList(ticketState.value?.fullTicketPagination?.nextPage);
    };

    onMounted(() => {
      ticketStore.getFullTicketList(1);
    });

    return { ticketState, onFetchTicketList, onChangePage, loading };
  },
});
</script>

<style></style>
